import fetch from 'unfetch'
import app from '@/app.js'

export function addVariant (variant, quantity) {
  const numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? (
    variant.inventory_quantity
  ) : null // null means they can add as many as they want

  return fetchCart().then(({ items }) => {
    const existing = items.filter(item => item.id === variant.id)[0] || {}
    const numRequested = (existing.quantity || 0) + quantity

    if (numAvailable !== null && numRequested > numAvailable) {
      const err = `There are only ${numAvailable} of that product available, requested ${numRequested}.`
      app.emit('error', err)
      throw new Error(err)
    } else {
      return addItemById(variant.id, quantity)
    }
  })
}

export function updateAddon (id, quantity) {
  return fetchCart().then(({ items }) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].variant_id === parseInt(id)) {
        return changeAddon(i + 1, quantity) // shopify cart is a 1-based index
      }
    }
  })
}

export function removeAddon (id) {
  return updateAddon(id, 0)
}

function changeAddon (line, quantity) {
  app.emit('cart:updating')

  return fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ line, quantity })
  }).then(res => res.json()).then(cart => {
    app.hydrate({ cart: cart })
    app.emit('cart:updated', { cart: cart })
    return cart
  })
}

/**
 * Warning: this does not check available products first
 */
export function addItemById (id, quantity, isUpsell) {
  app.emit('cart:updating');

  const $genderProperty = $('.js-gender-property');
  const $finalSaleProperty = $('.js-final-sale-property');
  let gender = '';

  if ($genderProperty.length) {
    gender = $genderProperty.val();
  }

  let formData = {
    'items': [
      {
        'id': id,
        'quantity': quantity,
        'properties': {
          '_gender': gender
        }
      }
    ]
  };

  if ($finalSaleProperty.length && !$finalSaleProperty.is(':disabled') && isUpsell != true) {
    let key = $finalSaleProperty.attr('name');
    let val = $finalSaleProperty.val();

    formData.items[0].properties[key] = val;
  }

  if (isUpsell) {
    formData.items[0].properties = {};
  }

  console.log(formData);

//JSON.stringify({ id, quantity })
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(r => r.json()).then(item => {
    return fetchCart().then(cart => {
      app.hydrate({ cart: cart })
      app.emit('cart:updated')
      app.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        }
      })
      // app.emit('updated', { item, cart })
      return { item, cart }
    })
  })
}

export function fetchCart () {
  return fetch('/cart.js', {
    method: 'GET',
    credentials: 'include'
  }).then(res => res.json())
}

// In-cart upsells

const $openUpsellForm = $('.js-trigger-upsell-form');
const $closeUpsellForm = $('.js-close-upsell-form');
const $upsellNext = $('.js-upsell-next');
const $upsellPrev = $('.js-upsell-prev');
const $upsellScroll = $('.js-upsell-scroll');
const upsellActive = 'active';

$openUpsellForm.click(function() {
  const $upsellForm = $(this).closest('.js-upsell-module').find('.js-upsell-form');
  $upsellForm.addClass(upsellActive);
});

$closeUpsellForm.click(function() {
  const $upsellForm = $(this).closest('.js-upsell-module').find('.js-upsell-form');
  $upsellForm.removeClass(upsellActive);
});

$('.js-upsell-option').on('change', function() {
  const variant = parseInt($(this).attr('data-variant'));

  if ($(this).prop('checked') == true) {
    addItemById(variant, 1, true);
    $('.js-upsell-form').removeClass(upsellActive);

    $(this).prop('checked', false);
  }
});

function AddSingleOptionProduct() {
	let upsellProducts = $('.js-upsell-module');

	upsellProducts.each(function () {
		let upsellProduct = $(this);
		let $singleOptionUpsellForm = $(this).find('.js-trigger-upsell-single-option-form');

		if ($singleOptionUpsellForm) {
			$singleOptionUpsellForm.click(function () {
				let variant = parseInt(upsellProduct.attr('data-upsell-single-variant'));

				if (variant) {
					addItemById(variant, 1, true);
				}
			});
		}
	});
}

AddSingleOptionProduct();

$upsellNext.click(function() {
  const width = $('.js-upsell-module').width();
  const currentPos = $upsellScroll.scrollLeft();
  const newScroll = currentPos + width;

  $('.js-upsell-scroll').animate(
    {
      scrollLeft: newScroll,
    }, 300
  );
});

$upsellPrev.click(function() {
  const width = $('.js-upsell-module').width();
  const currentPos = $upsellScroll.scrollLeft();
  const newScroll = currentPos - width;

  $('.js-upsell-scroll').animate(
    {
      scrollLeft: newScroll,
    }, 300
  );

});

